import Utils from '../../modules/utils'

const swapVpoCad = (vpoId, styleNumber, callbackFunc) => {
  const url = 'swap_vpo_cad'
  let data = {vpoId, styleNumber}
  Utils.post(url, data, callbackFunc)
}

export {swapVpoCad}
